export default __webpack_public_path__ + "static/media/logo.4ff49ae6.png";